import React from "react";
import { Container } from "./App/container";
import store from "./App/redux/store";
import { Provider } from "react-redux";

function App() {
  return (
    <Provider className="App" store={store}>
      <Container />
    </Provider>
  );
}

export default App;
